import { useMemo } from "react";

import { useSelector } from "metabase/lib/redux";
import { getMetadata } from "metabase/selectors/metadata";
import type Question from "metabase-lib/v1/Question";
import type {
  CardDisplayType,
  DatabaseId,
  VisualizationSettings,
} from "metabase-types/api";

import {
  DEFAULT_RESULT_DISPLAY,
  DEFAULT_RESULT_SETTINGS,
} from "../state/reducer";
import { createNativeQuestion } from "../utils/question";

/**
 * Derive a `Question` from a data source and some SQL.
 *
 * Questions are always derived and never stored: they hold a reference to the
 * metadata graph, which changes independently of the workbench.
 */
export function useTabQuestion(
  databaseId: DatabaseId | null,
  sql: string,
  display: CardDisplayType = DEFAULT_RESULT_DISPLAY,
  visualizationSettings: VisualizationSettings = DEFAULT_RESULT_SETTINGS,
): Question {
  const metadata = useSelector(getMetadata);
  return useMemo(
    () =>
      createNativeQuestion({
        databaseId,
        sql,
        metadata,
        display,
        visualizationSettings,
      }),
    [databaseId, display, metadata, sql, visualizationSettings],
  );
}
